import { render, staticRenderFns } from "./saveThematicDialog.vue?vue&type=template&id=2ef0faac"
import script from "./saveThematicDialog.vue?vue&type=script&lang=js"
export * from "./saveThematicDialog.vue?vue&type=script&lang=js"
import style0 from "./saveThematicDialog.vue?vue&type=style&index=0&id=2ef0faac&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports